import { STORY_STATUSES, Story } from 'types/components/Story';

export const isAbleToPublishStory = (data: Story) => {
  const { publishDate, status } = data;
  if ((status === STORY_STATUSES.UNPUBLISHED || status === STORY_STATUSES.DRAFT) && !publishDate) {
    return true;
  }
  return false;
};

export const isAbleToUnpublishStory = (data: Story) => {
  const { expirationDate, status } = data;
  if (status === STORY_STATUSES.PUBLISHED && !expirationDate) {
    return true;
  }
  return false;
};

export const isAbleToDeleteStory = (data: Story) => {
  const { status } = data;
  if (
    status !== STORY_STATUSES.PUBLISHED &&
    status !== STORY_STATUSES.EXPIRED &&
    status !== STORY_STATUSES.UNPUBLISHED
  ) {
    return true;
  }
  return false;
};
